const GuestHomePage = () => {
    return (
        <div>
            <h1>Guest Home Page</h1>
            <p>This is the Guest Home page content.</p>
        </div>
    );
}   
export default GuestHomePage;